module.exports = __webpack_public_path__ + "jpg/no-avatar.jpg?96f72ef36442a69e42f61d90ac3bc23d";